// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-text-page-js": () => import("/opt/build/repo/src/templates/text-page.js" /* webpackChunkName: "component---src-templates-text-page-js" */),
  "component---src-templates-leistungen-js": () => import("/opt/build/repo/src/templates/leistungen.js" /* webpackChunkName: "component---src-templates-leistungen-js" */),
  "component---src-templates-product-page-js": () => import("/opt/build/repo/src/templates/product-page.js" /* webpackChunkName: "component---src-templates-product-page-js" */),
  "component---src-templates-projekt-js": () => import("/opt/build/repo/src/templates/projekt.js" /* webpackChunkName: "component---src-templates-projekt-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tags-index-js": () => import("/opt/build/repo/src/pages/tags/index.js" /* webpackChunkName: "component---src-pages-tags-index-js" */)
}

exports.data = () => import("/opt/build/repo/.cache/data.json")

